var _polygon, _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCreateNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "31.75 12.94 19.15 25.54 17.48 29.94 22.08 28.62 35.09 16.28 31.75 12.94",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.05,6.64l-3.47,3.47,3.41,3.41,3.58-3.39c-.41-1.1-2.36-3.07-3.52-3.49Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.02,23.45c-1.11,0-2,.89-2,2v16H6.36V8.63h15.84c1.11,0,2-.89,2-2s-.89-2-2-2H4.36c-1.11,0-2,.89-2,2V43.45c0,1.11,.89,2,2,2H41.02c1.11,0,2-.89,2-2V25.45c0-1.11-.89-2-2-2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.54,4.95c-1-.92-3.57-3-5.92-2.23-.3,.1-.57,.27-.8,.49L16.02,23.02c-.2,.2-.36,.44-.46,.7l-3.25,8.54c-.27,.71-.12,1.51,.4,2.06,.38,.42,.92,.65,1.47,.65,.19,0,.37-.03,.55-.08l8.92-2.57c.31-.09,.59-.25,.82-.47L44.97,12.42c.28-.27,.48-.61,.57-.98,.68-2.82-2.12-5.68-2.99-6.49ZM22.08,28.62l-4.61,1.33,1.67-4.4,12.6-12.6,3.34,3.34-13.01,12.34Zm15.91-15.09l-3.41-3.41,3.47-3.47c1.16,.43,3.11,2.39,3.52,3.49l-3.58,3.39Z",
    fill: outlineColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 48,
    height: 48,
    fill: "none"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.26,
    y: 20.1,
    width: 24,
    height: 24,
    fill: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.26,
    y: 20.1,
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCreateNew);
export default __webpack_public_path__ + "static/media/ico-create-new.c6e291b48b72cb7a9af58da2252577b8.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;